module.exports = __webpack_public_path__ + "img/logo.e6904666.png";